"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueTransaction = void 0;
const consts_1 = require("../../consts");
const consts_2 = require("../../consts");
const BaseTransaction_1 = require("./BaseTransaction");
const TransactionType_1 = __importDefault(require("./TransactionType"));
class IssueTransaction extends BaseTransaction_1.BaseTransaction {
    constructor(obj = {}) {
        super(Object.assign({ version: consts_1.TX_VERSION.ISSUE }, obj));
        this.type = TransactionType_1.default.IssueTransaction;
    }
    static deserializeExclusive(_ss, _tx) {
        return {};
    }
    get exclusiveData() {
        return {};
    }
    get fees() {
        if (this.version >= 1) {
            return 0;
        }
        if (this.outputs.every((p) => p.assetId === consts_2.ASSET_ID.NEO || p.assetId === consts_2.ASSET_ID.GAS)) {
            return 0;
        }
        return consts_2.DEFAULT_SYSFEE.issueTransaction;
    }
    serializeExclusive() {
        return "";
    }
    equals(other) {
        if (this.type !== other.type) {
            return false;
        }
        if (other instanceof IssueTransaction) {
            return this.hash === other.hash;
        }
        return this.hash === new IssueTransaction(other).hash;
    }
}
exports.IssueTransaction = IssueTransaction;
exports.default = IssueTransaction;
